export const ISSUED_ITEMS_CREATE_CONTAINER_TAG_NAME = 'issued-items-create-container';
